
import LockCircle from "../../../assets/outline/LockCircle.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function LockCircleIcon({ className, dataTestid = "LockCircleIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <LockCircle data-testid={dataTestid} className={classes} {...rest} />
  );
}
